var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { defineMessages, FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";
var messages = defineMessages({
    main_sports: {
        id: "main.sports",
        defaultMessage: "Спорт",
    },
    main_live: {
        id: "main.live",
        defaultMessage: "Live",
    },
    main_games: {
        id: "main.games",
        defaultMessage: "Игры",
    },
});
var MenuTabs = /** @class */ (function (_super) {
    __extends(MenuTabs, _super);
    function MenuTabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            gameActive: window.location.pathname,
        };
        return _this;
    }
    MenuTabs.prototype.componentDidUpdate = function (_, prevState) {
        if (prevState.gameActive !== window.location.pathname) {
            this.setState({
                gameActive: window.location.pathname,
            });
        }
    };
    MenuTabs.prototype.render = function () {
        var props = this.props;
        var gameActive = this.state.gameActive;
        var gamesActive = gameActive.includes("/games") ? "active" : "";
        var sportActive = !gamesActive && props.activeTab === "sport" ? "active" : "";
        var liveActive = !gamesActive && props.activeTab === "live" ? "active" : "";
        return (_jsx("div", __assign({ className: "tabmenu" }, { children: _jsxs("ul", __assign({ className: "tabs", role: "tablist" }, { children: [_jsx("li", __assign({ className: liveActive }, { children: _jsx(FormattedMessage, __assign({}, messages.main_live, { children: function (m) { return (_jsx("button", __assign({ onClick: function () { return props.tabClick("main-live"); }, className: "tabmenu__live" }, { children: m }))); } })) })), _jsx("li", __assign({ className: sportActive }, { children: _jsx(FormattedMessage, __assign({}, messages.main_sports, { children: function (m) { return (_jsx("button", __assign({ onClick: function () { return props.tabClick("sport"); }, className: "tabmenu__line" }, { children: m }))); } })) })), _jsx("li", __assign({ className: gamesActive }, { children: _jsx(FormattedMessage, __assign({}, messages.main_games, { children: function (m) { return (_jsx("button", __assign({ onClick: function () { return props.tabClick("games"); }, className: "tabmenu__game" }, { children: m }))); } })) }))] })) })));
    };
    return MenuTabs;
}(React.Component));
var mapStateToProps = function (state) { return ({
    gamblerId: state.auth.user.gamblerId,
}); };
export default withRouter(connect(mapStateToProps)(MenuTabs));



// WEBPACK FOOTER //
// ./src/components/menu/MenuTabs.jsx